export const collections = [
  'Founders', 
  'Signature', 
  'Designer', 
  'ADU',
  'Benchmark',
  'H2A',
  'Manzanita',
  'Mountain Home'
];